import { RadioButtonGroup } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';
import { ISeoLinksTab } from '../../../common/types/seoTabsLinks';

interface ISeoTabsProps {
  tabs: ISeoLinksTab[];
  value: number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: number) => void;
}

export const SeoTabs = ({ tabs, value, onChange }: ISeoTabsProps) => {
  const options = React.useMemo(
    () =>
      tabs.map((tab, index) => ({
        label: tab.title,
        value: index,
      })),
    [tabs],
  );

  return (
    <div className={style['tab-buttons']} data-testid="QuickLinksTabs">
      <RadioButtonGroup spliced options={options} value={value} onChange={onChange} />
    </div>
  );
};
